export class AppUserService {
    constructor(AppStoreService, DataApiService) {
        'ngInject';
        this.AppStoreService = AppStoreService;
        this.DataApiService = DataApiService;
    }

    isNewUser() {
        return this.AppStoreService.get('global.isNewUser');
    }

    isAuthenticated() {
        return this.AppStoreService.get('global.isUserAuthenticated');
    }

    isHipaaAuthorized() {
        return this.AppStoreService.get('user.hipaaAuthorized')
    }

    getUserFullName() {
        const firstName = this.AppStoreService.get('user.firstName') || ''
        const lastName = this.AppStoreService.get('user.lastName') || ''
        return `${firstName} ${lastName}`
    }

    checkEmailAvailability(emailAddress) {
        return this.DataApiService.checkEmailAvailability(emailAddress);
    }

    loginUser(email, password) {
        return this.DataApiService.loginUser(email, password)
            .then((result) => {
                this.AppStoreService.set('global.isNewUser', false);
                this.AppStoreService.set('global.isUserAuthenticated', true);
                this.AppStoreService.set('user.email', email);
                this.AppStoreService.set('user.firstName', result.firstName);
                this.AppStoreService.set('user.lastName', result.lastName);
                this.AppStoreService.set('user.hipaaAuthorized', result.hipaaAuthorized);
            });
    }

    signupUser(userInfo) {
        return this.DataApiService.signupUser(userInfo)
            .then((result) => {
                this.AppStoreService.set('global.isNewUser', true);
                this.AppStoreService.set('global.isUserAuthenticated', true);
                this.AppStoreService.set('user', {
                    email: result.email,
                    firstName: result.firstName,
                    lastName: result.lastName,
                    hipaaAuthorized: result.hipaaAuthorized,
                });
            });
    }

    signupPatientConnectionUser(userInfo) {
        return this.DataApiService.signupPatientConnectionUser(userInfo).then((result) => {
            this.AppStoreService.set('global.isNewUser', true);
            this.AppStoreService.set('user', {
                email: result.email,
                firstName: result.firstName,
                lastName: result.lastName,
                hipaaAuthorized: result.hipaaAuthorized,
            });
            return result;
        });
    }

    verifyPatientConnection(emailToken, verifyFields, confirmUser) {
        return this.DataApiService.verifyPatientConnection(emailToken, verifyFields, confirmUser)
            .then((model) => {
                this.AppStoreService.set('global.isNewUser', true);
                this.AppStoreService.set('global.isUserAuthenticated', true);
                this.AppStoreService.set('user.email', model.patientConnection.registrationEmail);

                return model
            })
    }

    logOutUser() {
        this.AppStoreService.reset();
        return this.DataApiService.logoutUser()
    }

    authorizeHipaa(result) {
        const { hipaaAuthorized, hipaaAuthorizedAt, hipaaAuthorizedVersion } = result
        return this.DataApiService.authorizeHipaa({
            authorized: hipaaAuthorized,
            authorizedAt: hipaaAuthorizedAt,
            authorizedVersion: hipaaAuthorizedVersion
        })
    }
}



// WEBPACK FOOTER //
// ./src/app/services/appUser.service.js